import { aiLogApi, AiLogFilterParams, UpdateAiLogResolutionReq } from '../api/aiLogApi';
import { PaginationData } from '../models/paginationData';
import type {
    AdminAiLogResolution,
    AdminAiRequestLog,
    AdminAiRequestLogDetail,
} from '../types/aiLog';
import { useBaseMutation, useBaseQuery, useInvalidateQueries } from './useBaseQuery';

export const aiLogKeys = {
    all: ['aiLog'] as const,
    list: (params: AiLogFilterParams) => [...aiLogKeys.all, 'list', params] as const,
    detail: (logId: number) => [...aiLogKeys.all, 'detail', logId] as const,
};

export const useAiRequestLogs = (params: AiLogFilterParams) =>
    useBaseQuery<PaginationData<AdminAiRequestLog>>(
        aiLogKeys.list(params),
        () => aiLogApi.getRequestLogs(params),
        { staleTime: 30 * 1000 },
    );

export const useAiRequestLogDetail = (logId?: number) =>
    useBaseQuery<AdminAiRequestLogDetail>(
        aiLogKeys.detail(logId ?? 0),
        () => aiLogApi.getRequestLogDetail(logId!),
        { enabled: !!logId },
    );

export const useUpdateAiRequestLogResolution = () => {
    const { invalidate } = useInvalidateQueries();
    return useBaseMutation<
        { logId: number; data: UpdateAiLogResolutionReq },
        AdminAiLogResolution
    >(
        ({ logId, data }) => aiLogApi.updateRequestLogResolution(logId, data),
        {
            onSuccess: () => {
                invalidate(aiLogKeys.all);
            },
        },
    );
};
